import React, { useEffect, useState } from "react";
import classes from "./DoubleSelect.module.css"
import { monthNames } from "../../../common/links";

const DoubleSelect = function({map, settingFirstCallback, settingSecondCallback, ...props}){

    const [selectedYear, setYear] = useState(0);
    const [months, setMonths] = useState([]);
    const [selectedMonth, setMonth] = useState(0);
    const years = Array.from(map.keys());

    useEffect(()=>{
        if (selectedYear!==0){
            setMonths(Array.from(map.get(selectedYear)));
            setMonth(map.get(selectedYear)[0]);
        }
    },[selectedYear])


    useEffect(()=>{
        if (selectedMonth!==0){
            settingFirstCallback(selectedYear);
            settingSecondCallback(selectedMonth);
        }
    },[selectedMonth])

    return(
        <div className={classes.doubleSelect}>
            <select className={classes.firstSelect} value={selectedYear} onChange={event => setYear(event.target.value)}>
                <option disabled value={0}>Выберите год</option>
                {years.map(item =>
                <option key={item} value={item}>{item}</option>
                )}
            </select>
            <select className={classes.secondSelect} value={selectedMonth} onClick={event => setMonth(event.target.value)} onChange={event => setMonth(event.target.value)} >
                <option disabled value={0}>Выберите месяц</option>
                {months.map(item =>
                <option key={item} value={item}>{monthNames[item]}</option>
                )}
            </select>
        </div>
    )
}

export default DoubleSelect;